import { render, staticRenderFns } from "./viewchange.vue?vue&type=template&id=48c7d8a3&scoped=true"
import script from "./viewchange.vue?vue&type=script&lang=js"
export * from "./viewchange.vue?vue&type=script&lang=js"
import style0 from "./viewchange.vue?vue&type=style&index=0&id=48c7d8a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7d8a3",
  null
  
)

export default component.exports